import { WoocommerceCart } from '@contracts/context/woocommerceCart'

const KEY = 'woo-next-cart'

interface StoredCart {
	cart: WoocommerceCart
	timestamp: number
}

export const setStoredCart = (cart: WoocommerceCart): void => {
	if (typeof window === 'undefined' || !cart) return

	const payload: StoredCart = { cart, timestamp: Date.now() }
	window.localStorage.setItem(KEY, JSON.stringify(payload))
}

export const getStoredCart = (): { cart: WoocommerceCart; timestamp: number } | null => {
	if (typeof window === 'undefined') return null

	const raw = window.localStorage.getItem(KEY)
	if (!raw || raw === 'null') return null

	try {
		const parsed = JSON.parse(raw)

		// Wrapped: { cart, timestamp }
		if (parsed && typeof parsed === 'object' && parsed.cart && parsed.cart.__typename === 'Cart') {
			return { cart: parsed.cart, timestamp: parsed.timestamp ?? 0 }
		}

		// Legacy raw cart written directly to storage
		if (parsed && typeof parsed === 'object' && parsed.__typename === 'Cart') {
			return { cart: parsed, timestamp: parsed.timestamp ?? 0 }
		}
	} catch {
		return null
	}

	return null
}

export const clearStoredCart = (): void => {
	if (typeof window === 'undefined') return
	window.localStorage.removeItem(KEY)
}

export const touchStoredCartTimestamp = (): void => {
	const current = getStoredCart()
	if (current) setStoredCart(current.cart)
}
